import { useEffect, useMemo } from "react"
import { useAppSelector } from "../redux"
import { getAnalyticsProperties, logAnalyticsEvent } from "../services"
import { AnalyticsEvents, AnalyticsProducts, StripeProducts } from "../types"

const LS_KEY = "SubscriptionPlan"

export const useSubscription = (stripeProducts: StripeProducts) => {
  const user = useAppSelector((state) => state.app.user)

  const SubscriptionPlans = useMemo(() => {
    return Object.values(stripeProducts)
  }, [stripeProducts])

  useEffect(() => {
    if (!user || !user?.subscriptionPlan || !user?.subscriptionState) return
    if (!SubscriptionPlans.length) return

    const processSubscriptionPlan = () => {
      try {
        const currentPlanName = user?.subscriptionPlan
        const prevPlanName = localStorage.getItem(LS_KEY)

        if (prevPlanName) {
          const prevPlan = SubscriptionPlans.find(
            (e) => e?.name?.toLowerCase() === prevPlanName?.toLowerCase(),
          )
          const currentPlan = SubscriptionPlans.find(
            (e) => e?.name?.toLowerCase() === currentPlanName?.toLowerCase(),
          )
          const prevPlanPrice = prevPlan?.prices?.[0]?.unit_amount || 0
          const currentPlanPrice = currentPlan?.prices?.[0]?.unit_amount || 0

          if (prevPlanPrice < currentPlanPrice) {
            logAnalyticsEvent(
              AnalyticsEvents.subscription_upgraded,
              getAnalyticsProperties(AnalyticsProducts.subscription),
            )
          } else if (prevPlanPrice > currentPlanPrice) {
            logAnalyticsEvent(
              AnalyticsEvents.subscription_downgraded,
              getAnalyticsProperties(AnalyticsProducts.subscription),
            )
          }
        }
        if (prevPlanName !== currentPlanName) {
          localStorage.setItem(LS_KEY, currentPlanName)
        }
      } catch (error) {
        console.error("Error processing subscription plan", error)
        logAnalyticsEvent(
          AnalyticsEvents.subscription_processing_failed,
          getAnalyticsProperties(AnalyticsProducts.subscription),
        )
      }
    }

    processSubscriptionPlan()
  }, [user, SubscriptionPlans])
}
